import BaseModal from "./BaseModal";
import QRCode from "../QRCode";
import "../../css/GetQRCodeModal.css";

/**
 * A modal component for getting a QR code.
 *
 * @component
 * @param props - Component props.
 * @param {Boolean} props.isOpen - Controls whether the modal is open or closed.
 * @param {Function} props.onRequestClose - Callback function triggered to close the modal, passed down to BaseModal.
 * @param {String} [props.width='auto'] - Optional width of the modal content, defaults to 'auto' if not provided.
 * @returns {JSX.Element} The rendered GetQRCodeModal component.
 */
const GetQRCodeModal = ({
  isOpen,
  onRequestClose,
  width,
  restaurantName,
  restaurantURL,
}) => {
  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose} width={width}>
      <div className="GetQRCodeModal">
        <p className="GetQRCodeModal-description">
          download a qr code for customers to easily access your restaurant's
          menu with just a scan!
        </p>
        <QRCode restaurantName={restaurantName} restaurantURL={restaurantURL} />
      </div>
    </BaseModal>
  );
};

export default GetQRCodeModal;
